import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { ClassingContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { createGroupTeamTranfer, getGroupTeam, getGroupTeamForFilterClass } from '../../../actions/groups'
import Loader from '../../../components/Loader'
import Table from '../../../components/Table'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { handleSortFio } from '../../../utils/handleSortFio'
import { Input, Select } from '../../../components/ModalInputs'
import { useFormik } from 'formik'
import moment from 'moment'
import { getCurrentYearUtils } from '../../../utils/classBook'
import { createNotification } from '../../../components/Notifications/Notifications'

// id соответствует status_value, передаваемому в API
const ACTIONS = [
  { id: 1, name: 'Перевод в другой класс', needTargetClass: true },
  { id: 2, name: 'Перевод из другого класса', needTargetClass: false },
]

export default function Team() {

  const dispatch = useDispatch()
  const { classId, closeModal, infoCreateChange } = useContext(ClassingContext)
  const { filterClass, groupInfo, groupTeam, modalLoading: loading } = useSelector(state => state.groups)
  const { schoolYears } = useSelector(state => state.common)

  const [sortArr, setSortArr] = useState(false)
  const [arr, setArr] = useState([])
  const [selectedStudents, setSelectedStudents] = useState([])

  useEffect(() => {
    if (classId && classId !== 'add') dispatch(getGroupTeam(classId))
  }, [])

  useEffect(() => {
    if (!groupInfo || !schoolYears?.length) return
    const currentSchoolYear = getCurrentYearUtils(schoolYears, moment())
    if (!currentSchoolYear) return
    dispatch(getGroupTeamForFilterClass(currentSchoolYear, groupInfo.year))
  }, [groupInfo, schoolYears])

  useEffect(() => {
    groupTeam && setArr([...groupTeam])
  }, [groupTeam])

  const handleCreate = async () => {
    if (!selectedStudents.length) {
      createNotification('error', 'Выберите хотя бы одного учащегося')
      return
    }
    if (!values.date) {
      createNotification('error', 'Укажите дату')
      return
    }
    if (!values.prikaz) {
      createNotification('error', 'Укажите приказ')
      return
    }
    if (!values.protocol_num) {
      createNotification('error', 'Укажите № протокола педсовета')
      return
    }
    if (!values.protocol_date) {
      createNotification('error', 'Укажите дату протокола')
      return
    }

    const action = ACTIONS.find(a => a.id === Number(values.status_value))
    if (action?.needTargetClass && !values.class_id) {
      createNotification('error', 'Укажите целевой класс')
      return
    }

    const payload = {
      date: values.date,
      status_type: action.name,
      status_value: action.id,
      selected_students: selectedStudents,
      prikaz: values.prikaz,
      protocol_num: values.protocol_num,
      protocol_date: values.protocol_date,
      record_id: classId,
    }
    if (action?.needTargetClass) {
      const target = filterClass?.find(el => el.xp_key === Number(values.class_id))
      payload.class_id = Number(values.class_id)
      payload.class_name = target?.name || ''
    }

    await dispatch(createGroupTeamTranfer(payload))
    setSelectedStudents([])
  }

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: {
      status_value: ACTIONS[0].id,
      date: moment().format('YYYY-MM-DD'),
      prikaz: '',
      protocol_num: '',
      protocol_date: moment().format('YYYY-MM-DD'),
      class_id: '',
    },
    enableReinitialize: false,
    onSubmit: handleCreate
  })

  const handleChangeStudents = (mid) => {
    setSelectedStudents((prev) =>
      prev.includes(mid) ? prev.filter(id => id !== mid) : [...prev, mid]
    )
  }

  const renderRow = ({ calc_fio, calc_status, calc_date, mid }) => (
    <tr
      key={mid}
      onClick={() => handleChangeStudents(mid)}
      style={{ backgroundColor: selectedStudents.includes(mid) ? '#3689FF' : '', cursor: 'pointer' }}
    >
      <td>{calc_fio}</td>
      <td>{calc_status}</td>
      <td>{calc_date}</td>
    </tr>
  )

  const handleSort = () => {
    handleSortFio(arr, sortArr)
    setSortArr(!sortArr)
  }

  const currentAction = ACTIONS.find(a => a.id === Number(values.status_value)) || ACTIONS[0]

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          {loading
            ? <Loader />
            : !arr?.length
              ? <h1>Слушатели не внесены</h1>
              : (
                <>
                  <div className={styles.tableScroll}>
                    <Table className={styles.tableFooter} maxHeight='45vh'>
                      <thead>
                        <tr>
                          <th onClick={handleSort} style={{ cursor: 'pointer' }}>ФИО</th>
                          <th>Статус</th>
                          <th>Дата</th>
                        </tr>
                      </thead>
                      <tbody>
                        {arr.map(renderRow)}
                      </tbody>
                    </Table>
                  </div>
                  <br />
                  <div className={styles.actionGrid}>
                    <div className={styles.actionCell}>
                      <Select
                        label='Действие'
                        value={values.status_value}
                        onChange={handleChange}
                        name='status_value'
                      >
                        {ACTIONS.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
                      </Select>
                    </div>

                    {currentAction.needTargetClass && (
                      <div className={styles.actionCell}>
                        <Select
                          label='В класс *'
                          value={values.class_id}
                          onChange={handleChange}
                          name='class_id'
                        >
                          <option value=''>— выбрать —</option>
                          {filterClass?.map((el) => (
                            <option key={el.xp_key} value={el.xp_key}>{`${el.name} ${el.liter || ''}`}</option>
                          ))}
                        </Select>
                      </div>
                    )}

                    <div className={styles.actionCell}>
                      <Input
                        type='date'
                        label='Дата *'
                        name='date'
                        value={values.date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className={styles.actionGrid}>
                    <div className={styles.actionCell}>
                      <Input
                        label='Приказ *'
                        value={values.prikaz}
                        onChange={handleChange}
                        name='prikaz'
                      />
                    </div>
                    <div className={styles.actionCell}>
                      <Input
                        label='№ протокола педсовета *'
                        value={values.protocol_num}
                        onChange={handleChange}
                        name='protocol_num'
                      />
                    </div>
                    <div className={styles.actionCell}>
                      <Input
                        label='от *'
                        type='date'
                        value={values.protocol_date}
                        onChange={handleChange}
                        name='protocol_date'
                      />
                    </div>
                    <Button
                      className={styles.actionBtn}
                      onClick={handleSubmit}
                    >
                      Выполнить
                    </Button>
                  </div>
                </>
              )
          }
        </div>
      </div>
      <ModalFooter closeModal={closeModal} handleSubmit={closeModal} infoCreateChange={infoCreateChange} />
    </>
  )
}
